/**
 * 获取环境变量
 */
let envName = '';
let platType = 0;
/**
1	android
2	ios
3	微信里的 h5
4	官网PC版
5	浏览器里的 h5
6	微信小程序
10	微信小程序TMC预订
13	支付宝小程序
 */
/**
 * app 亚朵app
 * wechatMini 微信小程序
 * aliMini 支付宝小程序
 * ali 支付宝H5
 * wechat 微信H5
 * h5 普通浏览器
 */
export default function getEnv() {
    return new Promise((resolve) => {
        // 如果已经存在
        if (envName) {
            resolve({
                envName,
                platType,
            });
        } else {
            const returnTo = function setEnv(env) {
                envName = env.envName;
                platType = env.platType;
                resolve({
                    envName,
                    platType,
                });
            };
            const ua = navigator.userAgent.toLowerCase();
            // alert(ua);
            if (ua.indexOf('atourbrowser') > -1) {
                // app
                const envNameStr = 'app';
                let platTypeNum = 1;
                if (ua.indexOf('ios') > -1) {
                    platTypeNum = 2;
                } else {
                    if (ua.indexOf('harmony') > -1) {
                        platTypeNum = 25;
                    } else {
                        platTypeNum = 1;
                    }
                }
                returnTo({
                    envName: envNameStr,
                    platType: platTypeNum,
                });
            } else if (ua.indexOf('alipayclient') > -1) {
                // 支付宝
                if (window.my) {
                    window.my.getEnv((res) => {
                        if (res.miniprogram) {
                            // aliMini
                            returnTo({
                                envName: 'aliMini',
                                platType: 13,
                            });
                        } else {
                            // ali
                            returnTo({
                                envName: 'ali',
                                platType: 5,
                            });
                        }
                    });
                } else {
                    console.log('未加载ali sdk');
                    // H5
                    returnTo({
                        envName: 'ali',
                        platType: 5,
                    });
                }
            } else if (ua.indexOf('micromessenger') > -1 || ua.indexOf('miniprogram') > -1) {
                // alert(window.wx);
                // 微信
                if (window.wx && window.wx.miniProgram) {
                    window.wx.miniProgram.getEnv(res => {
                        if (res.miniprogram) {
                            // wechatMini
                            returnTo({
                                envName: 'wechatMini',
                                platType: 6,
                            });
                        } else {
                            // wechat
                            returnTo({
                                envName: 'wechat',
                                platType: 3,
                            });
                        }
                    });
                } else {
                    console.log('未加载wechat sdk');
                    // wechat
                    returnTo({
                        envName: 'wechat',
                        platType: 3,
                    });
                }
            } else if (ua.indexOf('xhsminiweb') > -1) { // 小红书H5
                if (window.XHSOpenSDK) {
                    returnTo({
                        envName: 'xiaoHongShu',
                        platType: 19,
                    });
                } else {
                    returnTo({
                        envName: 'h5',
                        platType: 5,
                    });
                }
            } else {
                // H5
                returnTo({
                    envName: 'h5',
                    platType: 5,
                });
            }
        }
    });
}
